export default "__VITE_ASSET__B8QCjSer__"